import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../data/initialState.layout.data';

const commonSlice = createSlice({
  name: 'layout',
  initialState: initialState,
  reducers: {
    toggleSideBar: (state, action) => {
      state.leftDrawerOpened = action.payload;
    },
    setMenu: (state, action) => {
      state.openMenu = action.payload;
    },
    setMenuId: (state, action) => {
      state.isOpen = [action.payload];
    },
  },
});

export const { toggleSideBar, setMenu, setMenuId } = commonSlice.actions;

export default commonSlice.reducer;
